<template>
  <div :style="{ height: contentHeight }">
    <RouterView />
    <BtnDialog />
    <CookieConsent v-if="appLoaded" @cookie-consent="handleCookieConsent" />
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
// import { getLanguageFileUpdate } from '@/lib/business-api'
import CookieConsent from '@/components/CookieConsent.vue'

export default {
  name: 'AppMain',
  components: {
    CookieConsent
  },
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      test: true,
      contentHeight: '100%',
      appLoaded: false
    }
  },
  computed: {
    ...mapState(['webConfig', 'logoAndBack', 'languageList', 'userInfo']),
    ...mapGetters(['language'])
  },
  watch: {
    $route(to) {
      localStorage.setItem('routerName', to.name)
      this.setLivechatClass()
    }
    // '$i18n.locale': {
    //   handler() {
    //     if (process.env.VUE_APP_ENV === 'production' || process.env.VUE_APP_ENV === 'staging') {
    //       // 正式环境才启用
    //       getLanguageFileUpdate()
    //     }
    //   },
    //   immediate: true
    // }
  },
  async created() {
    // if (sessionStorage.getItem('store')) {
    //   this.$store.replaceState({
    //     ...this.$store.state,
    //     ...JSON.parse(sessionStorage.getItem('store')),
    //     availableRoutes: []
    //   })
    // }

    // Only fetch language list if not already available in store
    if (!this.$store.state.languageList || this.$store.state.languageList.length === 0) {
      await this.get_language()
    }

    // 在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener('beforeunload', () => {
      sessionStorage.setItem('store', JSON.stringify(this.$store.state))
    })
  },
  mounted() {
    this.setLivechatClass()
    function checkIE() {
      return '-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style
    }
    if (checkIE()) {
      window.addEventListener(
        'hashchange',
        () => {
          console.log('ie' + window.location.hash)
          const currentPath = window.location.hash.slice(1)
          if (this.$route.path !== currentPath) {
            this.$router.push(currentPath)
          }
        },
        false
      )
    }

    window.abc = (func) => {
      typeof func === 'function' && func(null, null, null, this)
      return
    }

    this.$nextTick(() => {
      setTimeout(() => {
        this.appLoaded = true
      }, 300) // Small delay to ensure other components are loaded
    })

    // 动态计算高度，100vh在不同的适配情况下容易出现异常
    this.initHomeHeight()
  },
  methods: {
    async get_language() {
      const { data, code } = await this.$ajax({
        url: '/common/language',
        method: 'get'
      })
      if (code === 0) {
        this.$store.commit('setLanguageList', data)
        // Cache the language list for getLanguage() calls
        try {
          if (data && Array.isArray(data) && data.length > 0) {
            localStorage.setItem('cached_language_list', JSON.stringify(data))
          }
        } catch (error) {
          console.warn('Failed to cache language list:', error)
        }
      }
    },
    initHomeHeight() {
      const bodyComputedStyle = window.getComputedStyle(document.body)
      this.contentHeight =
        window.innerHeight -
        parseFloat(bodyComputedStyle.paddingTop) -
        parseFloat(bodyComputedStyle.paddingBottom) +
        'px'
      setTimeout(() => {
        this.initHomeHeight()
      }, 500)
      window.onresize = () => {
        this.initHomeHeight()
      }
      document.addEventListener(
        'keydown',
        (event) => {
          if (event.key === 'F11') {
            // 注意：此处不能直接判断全屏状态，因为F11操作是浏览器控制的
            setTimeout(() => {
              this.initHomeHeight()
            }, 500)
          }
        },
        true
      ) // 使用capture阶段，以便在事件冒泡前截获
    },
    reload() {
      if (this.$route.name === 'login' || this.$route.name === 'regist-real') {
        location.reload()
      } else {
        this.test = false
        this.$nextTick(() => {
          this.test = true
        })
      }
    },
    setLivechatClass() {
      if (this.$isApp && this.$route.path === '/online-service') {
        document.body.classList.remove('livechatshow')
      } else if (!this.$isApp && (this.$route.path === '/index' || this.$route.path === '/')) {
        document.body.classList.remove('livechatshow')
      } else {
        document.body.classList.add('livechatshow')
      }
    },
    handleCookieConsent(status) {
      console.log('Cookie consent status:', status)
      // You can implement additional logic based on consent status
      // For example, initialize analytics only if consent is accepted
    }
  }
}
</script>
